<template>
	<div>
		<h3>
			<q-icon class="icon-fleche"/>
			Interpellez Elisabeth Borne
		</h3>

		<p>
			Ecrivez à la Ministre de la Transition écologique et solidaire et dites-lui de mettre fin à la déforestation importée.</b>
		</p>

		<p>
			<strong>
			Cliquez ici : <a href="mailto:secretariat.ministre@ecologique-solidaire.gouv.fr?subject=Non%20%C3%A0%20l'huile%20de%20palme%20dans%20nos%20moteurs%20!&body=Madame%20Borne%2C%0A%0ACet%20%C3%A9t%C3%A9%20encore%2C%20vous%20d%C3%A9clariez%20sur%20France%20Inter%20%E2%80%9CLe%20sens%20de%20l'Histoire%20c'est%20bien%20de%20r%C3%A9duire%20les%20importations%20d'huile%20de%20palme.%20En%20France%20il%20n'y%20a%20plus%20d'avantage%20fiscal%20pour%20l%E2%80%99huile%20de%20palme%20en%20tant%20que%20biocarburant%22.%20Pourtant%20le%2019%20d%C3%A9cembre%202019%2C%20la%20Direction%20g%C3%A9n%C3%A9rale%20des%20douanes%20a%20fait%20circuler%20une%20note%20d%E2%80%99information%20aux%20f%C3%A9d%C3%A9rations%20professionnelles%20pour%20indiquer%20que%20le%20gouvernement%20souhaitait%20maintenir%20la%20niche%20fiscale%20sur%20les%20biocarburants%20%C3%A0%20base%20de%20distillat%20d%E2%80%99acide%20gras%20d%E2%80%99huile%20de%20palme.%20Il%20s%E2%80%99agit%20bien%20d%E2%80%99huile%20de%20palme%2C%20avec%20les%20m%C3%AAmes%20cons%C3%A9quences%20d%C3%A9sastreuses%20en%20termes%20de%20d%C3%A9forestation.%0A%0AContinuer%20%C3%A0%20promouvoir%20les%20exemptions%20fisclales%20pour%20les%20agrocarburants%20%C3%A0%20base%20d%E2%80%99huile%20de%20palme%20est%20incompatible%20avec%20la%20lutte%20contre%20la%20d%C3%A9forestation%20que%20les%20responsables%20politiques%20se%20doivent%20de%20mener.%20En%20effet%2C%20pour%20produire%20ces%20agrocarburants%20%C3%A0%20base%20d%E2%80%99huile%20de%20palme%2C%20on%20abat%20des%20for%C3%AAts%20tropicales%2C%20on%20d%C3%A9truit%20l%E2%80%99habitat%20d%E2%80%99esp%C3%A8ces%20menac%C3%A9es%20de%20disparition%20et%20l%E2%80%99on%20se%20prive%20d%E2%80%99%C3%A9normes%20puits%20de%20carbone%2C%20ce%20qui%20aggrave%20in%20fine%20le%20d%C3%A9r%C3%A8glement%20climatique.%0A%0ALes%20solutions%20sont%20connues%20et%20ne%20demandent%20qu%E2%80%99%C3%A0%20%C3%AAtre%20mises%20en%20%C5%93uvre.%20Il%20faut%20%3A%0A%0A-%20suspendre%20l%E2%80%99autorisation%20d%E2%80%99exploitation%20accord%C3%A9e%20%C3%A0%20la%20M%C3%A8de%20%3B%0A%0A-%20sortir%20des%20agrocarburants%20de%201%C3%A8re%20g%C3%A9n%C3%A9ration%2C%20%C3%A0%20commencer%20par%20ceux%20%C3%A0%20base%20d%E2%80%99huile%20de%20palme%20et%20de%20soja%20%3B%0A%0A-%20supprimer%20les%20avantages%20fiscaux%20accord%C3%A9s%20aux%20activit%C3%A9s%20et%20industries%20polluantes%20%3B%0A%0A-%20appliquer%20la%20Strat%C3%A9gie%20Nationale%20de%20Lutte%20contre%20la%20D%C3%A9forestation%20Import%C3%A9e%20(SNDI).%0A%0AIl%20y%20a%20urgence%20%C3%A0%20mettre%20un%20terme%20%C3%A0%20cette%20aberration%20%C3%A9cologique%20!%0A%0AMerci.%0A%0ACordialement%20" target="_blank" @click="track">secretariat.ministre@ecologique-solidaire.gouv.fr</a>
			</strong>
		</p>

		<p>
			Vous pouvez vous inspirer du message suivant. <u :class="{copy: true, copying: copying}" @click="copyToClipboard">Cliquez ici</u> pour le copier&nbsp;:
		</p>

		<p class="script" ref="texte">
				Madame Borne,
				<br/><br/>
				Cet été encore, vous déclariez sur France Inter “Le sens de l'Histoire c'est bien de réduire les importations d'huile de palme. En France il n'y a plus d'avantage fiscal pour l’huile de palme en tant que biocarburant". Pourtant le 19 décembre 2019, la Direction générale des douanes a fait circuler une note d’information aux fédérations professionnelles pour indiquer que le gouvernement souhaitait maintenir la niche fiscale sur les biocarburants à base de distillat d’acide gras d’huile de palme. Il s’agit bien d’huile de palme, avec les mêmes conséquences désastreuses en termes de déforestation.
				<br/><br/>
				Continuer à promouvoir les exemptions fiscales pour les agrocarburants à base d’huile de palme est incompatible avec la lutte contre la déforestation que les responsables politiques se doivent de mener. En effet, pour produire ces agrocarburants à base d’huile de palme, on abat des forêts tropicales, on détruit l’habitat d’espèces menacées de disparition et l’on se prive d’énormes puits de carbone, ce qui aggrave in fine le dérèglement climatique.
				<br/><br/>
				Les solutions sont connues et ne demandent qu’à être mises en œuvre. Il faut :
				<br/><br/>
				- suspendre l’autorisation d’exploitation accordée à la Mède ;
				<br/><br/>
				- sortir des agrocarburants de 1ère génération, à commencer par ceux à base d’huile de palme et de soja ;
				<br/><br/>
				- supprimer les avantages fiscaux accordés aux activités et industries polluantes ;
				<br/><br/>
				- appliquer la Stratégie Nationale de Lutte contre la Déforestation Importée (SNDI).
				<br/><br/>
				Il y a urgence à mettre un terme à cette aberration écologique !
				<br/><br/>
				Merci.
				<br/><br/>
				Cordialement
			</p>

	</div>
</template>

<script>
export default {
	data() {
		return {
			copying: false,
		}
	},
	methods: {
		track() {
			this.$count()
			this.$trackEvent("click", "message ministre")
		},
		copyToClipboard() {
			this.$copyToClipboard(this.$refs.texte.innerText)
			this.copying = true
			setTimeout(() => this.copying = false, 200)
		}
	}
}
</script>